import { createAction, props } from '@ngrx/store';
import { EnvironmentConfiguration } from 'src/app/authentication/model/configuration.model';

export const getEnvironmentConfig = createAction('[EnvironmentConfig] get config');
export const getEnvironmentConfigSuccess = createAction(
  '[EnvironmentConfig] get config success',
  props<{ config: EnvironmentConfiguration }>()
);
